import { useGraph } from "@features/builder/graph/graphAtoms"
import { lockMemberAtom } from "@features/builder/hooks/socketIOHooks"
import { SocketRoomPrefix } from "@features/builder/types"
import { useAtomValue } from "jotai"

const useNodeLock = ({ nodeId }: { nodeId: string }) => {
  const { graphId } = useGraph()
  const lockMember = useAtomValue(lockMemberAtom)

  if (!graphId || !nodeId) return undefined

  return lockMember.get(`${SocketRoomPrefix.CRDT}-${graphId}`)?.get(nodeId)
}

export default useNodeLock
